module.exports = ".readOnly {\n  position: absolute;\n  z-index: 1;\n  opacity: 0.5;\n  background-color: #EFEFEF;\n  height: 100%;\n  margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/non-compliance/non-compliance.component.scss
// module id = ./src/app/non-compliance/non-compliance.component.scss
// module chunks = main